<div  class="fx-col fx-gap-12">
  <div  class="fx-row fx-jc-start fx-ai-center">
    <div fxFlex  class="fx-col fx-gap-8">

      <div [ngClass]="'mat-line small-font consultant-info'">
        <div  class="fx-row fx-jc-start fx-ai-center fx-gap-8">
          <mat-icon class="folder-icon"
                    matTooltip="Click to view shared files"
                    [ngClass]="'folder-icon'"
                    (click)="toggleExpanded($event)">
            folder
          </mat-icon>
          <mat-icon class="expand-icon"
                    matTooltip="Expand/collapse shared files"
                    [ngClass]="{'expanded': isExpanded}"
                    (click)="toggleExpanded($event)">
            {{ isExpanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
          <b [ngStyle]="{ color: consultant.clientMatter === caseName ? '#d73a31' : '#333' }">
            {{consultant.name}}
          </b>
        </div>
        <div *ngIf="consultant.specialty"
             class="specialty-info">
          {{ consultant.specialty }}
        </div>
        <div *ngIf="consultant.facility"
             class="facility-info">
          {{ consultant.facility }}
        </div>
        <div *ngIf="consultant.clientMatter === caseName"
             class="client-indicator">
          <mat-icon class="person-icon"
                    color="warn"
                    matTooltip="Client Profile Account user">
            person
          </mat-icon>
          <span class="client-user-label">
            (Client user)
          </span>
        </div>
        <mat-icon *ngIf="consultant.highlighted"

                  color="warn"
                  style="margin-left: 8px; vertical-align: middle; display: inline-block"

                  aria-hidden="false"
                  aria-label="The file is shared with this consultant."
                  matTooltip="The file is shared with this consultant."
                  [ngClass]="'file-icon'">
          people
        </mat-icon>
      </div>

      <div [ngClass]="'mat-line small-font email-info'">
        <mat-icon class="email-icon">
          email
        </mat-icon>
        <span class="truncated-email"
              [title]="consultant.email">
          {{ consultant.email }}
        </span>
      </div>

      <div [ngClass]="'mat-line small-font profile-info'">
        <mat-icon class="info-icon">
          info
        </mat-icon>
        <span>
          {{
            isRestrictedProfile(consultant)
              ? 'This user can not see file comments and attachments.'
              : 'This user can see file comments and attachments.'
          }}
        </span>
      </div>
    </div>
  </div>

  <!-- Shared Files Section -->
  <div *ngIf="isExpanded"
       class="shared-files-section fx-col fx-gap-8"  >

    <div class="shared-files-header fx-row fx-jc-start fx-ai-center fx-gap-8"  >
      <mat-icon class="files-icon">
        description
      </mat-icon>
      <span class="shared-files-title">
        Shared Files ({{ getSharedFilesCount() }})
      </span>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="loadingSharedFiles"
         class="loading-indicator fx-row fx-jc-start fx-ai-center fx-gap-8"  >
      <mat-progress-spinner diameter="16"></mat-progress-spinner>
      <span>
        Loading shared files...
      </span>
    </div>

    <!-- Shared files list -->
    <div *ngIf="!loadingSharedFiles && hasSharedFiles()"
         class="shared-files-list fx-col fx-gap-4"  >
      <div *ngFor="let file of sharedFiles"
           class="shared-file-item fx-row fx-jc-start fx-ai-center fx-gap-8"  >
        <mat-icon class="file-icon">
          insert_drive_file
        </mat-icon>
        <span class="file-name"
              [title]="file.fileName">
          {{ file.fileName }}
        </span>
        <span *ngIf="file.parentFolderName"
              class="file-folder">
          ({{ file.parentFolderName }})
        </span>
      </div>
    </div>

    <!-- No shared files message -->
    <div *ngIf="!loadingSharedFiles && !hasSharedFiles()"
         class="no-shared-files fx-row fx-jc-start fx-ai-center fx-gap-8"  >
      <mat-icon class="info-icon">
        info
      </mat-icon>
      <span>
        No files are currently shared with this consultant.
      </span>
    </div>
  </div>

  <!-- Button section moved to bottom -->
  <div *ngIf="
      (selected && checkSelected(consultant)) || (selected && selectedFiles.length > 1 && !checkSelected(consultant))
    "
       class="button-section fx-row fx-jc-end fx-ai-center"  >

    <button *ngIf="selected && checkSelected(consultant)"
            color="warn"

            mat-flat-button
            matTooltip="Stop sharing selected files with this consultant."

            [ngClass]="'small-font'"
            (click)="$event.stopPropagation(); unShare(consultant)">
      <mat-icon>
        unshare
      </mat-icon>
      Unshare selected
    </button>

    <button *ngIf="selected && selectedFiles.length > 1 && !checkSelected(consultant)"
            color="warn"

            mat-flat-button
            matTooltip="Share selected files with this consultant."

            [ngClass]="'small-font'"
            (click)="$event.stopPropagation(); share(consultant)">
      <mat-icon>
        share
      </mat-icon>
      Share selected
    </button>
  </div>

  <div *ngIf="sharedFilesCount === 0 && selected"
       class="note">
    <mat-icon class="note-icon">
      folder_open
    </mat-icon>
    <div class="note-content">
      <strong>
        No shared files
      </strong>
      <br>
      This user has no shared files in this folder.
      <br>
      To see the files shared with this consultant, go to the
      <button class="red-background small-font"
              (click)="goToIndex($event)">
        <mat-icon>
          folder
        </mat-icon>
        INDEX
      </button>
      folder.
    </div>
  </div>
</div>
